/* eslint-disable no-console */
import mixpanel from 'mixpanel-browser';

import { EMixpanelEventNames, EMixpanelProperties } from '@webtrader/core/services/analysis/constants';

import { IMixpanelAnalysis, TMixpanelProperties } from './types';

const mixpanelToken = MIXPANEL_TOKEN;

class WebMixpanel implements IMixpanelAnalysis {
  constructor() {
    if (mixpanelToken) {
      mixpanel.init(mixpanelToken, {
        persistence: 'localStorage'
        /** Only enabled in Dev , to console log the mixpanel output */
        // debug: true
      });
    } else {
      console.error(
        'The Mixpanel token is missing. Kindly obtain it from other team members. For local development, consider adding the following token to your zshrc file: \n\nexport MIXPANEL_TOKEN=your_token_here'
      );
    }
  }

  public trackPageView = (page: string, properties?: TMixpanelProperties) => {
    if (mixpanelToken) {
      mixpanel?.track_pageview({
        [EMixpanelProperties.PAGE]: page,
        ...properties
      });
    }
  };

  public track = (eventName?: EMixpanelEventNames, properties?: TMixpanelProperties) => {
    if (!eventName) {
      console.error('Mixpanel event name is required');
      return;
    }
    if (mixpanelToken) {
      mixpanel?.track(eventName, properties);
    }
  };

  public identify = (userId: string) => {
    if (mixpanelToken) {
      mixpanel?.identify(userId);
    }
  };

  public reset = () => {
    if (mixpanelToken) {
      mixpanel?.reset();
    }
  };

  public registerSuperProperties = (properties?: TMixpanelProperties) => {
    if (properties && mixpanelToken) {
      mixpanel?.register(properties);
    }
  };

  public setUserProfile = (properties?: TMixpanelProperties) => {
    if (properties && mixpanelToken) {
      mixpanel?.people.set(properties);
    }
  };
}

export default new WebMixpanel();
